import { render } from "./UserTable3DWebview.vue?vue&type=template&id=566fe082&scoped=true&ts=true"
import script from "./UserTable3DWebview.vue?vue&type=script&lang=ts"
export * from "./UserTable3DWebview.vue?vue&type=script&lang=ts"

import "./UserTable3DWebview.vue?vue&type=style&index=0&id=566fe082&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566fe082"]])

export default __exports__